module.exports = __webpack_public_path__ + "img/knausgaard_Portrett2.35e5dd36.jpg";